import React from 'react';
import SearchableSelect from './SearchableSelect';
import { buildMatchFieldOptions, MATCH_TYPES } from '../utils/targetingListFields';

/**
 * Column-definition editor for a "Set Check" targeting list — lets a PM
 * define their own named columns (e.g. "company_name", "zip_code"), each
 * paired with a target Lead field (via the same SearchableSelect +
 * buildMatchFieldOptions every other match_field picker in this app uses)
 * and its own match strategy (MATCH_TYPES). Emits the exact
 * column_config shape the backend expects:
 * [{name, lead_field, match_type}].
 *
 * Props: columns [{name,lead_field,match_type}], onChange(nextColumns), allLeadFields.
 */
const rowStyle = {
  display: 'grid', gridTemplateColumns: '1fr 1.4fr 1fr auto', gap: '8px',
  alignItems: 'center', marginBottom: '6px',
};
const inputStyle = {
  padding: '6px 8px', borderRadius: '4px', border: '1px solid #ccc',
  fontSize: '13px', boxSizing: 'border-box', width: '100%',
};

export default function SetColumnEditor({ columns, onChange, allLeadFields }) {
  const rows = columns && columns.length ? columns : [{ name: '', lead_field: '', match_type: 'exact' }];

  const updateRow = (idx, patch) => {
    const next = rows.map((r, i) => (i === idx ? { ...r, ...patch } : r));
    onChange(next);
  };
  const addRow = () => onChange([...rows, { name: '', lead_field: '', match_type: 'exact' }]);
  const removeRow = (idx) => {
    const next = rows.filter((_, i) => i !== idx);
    onChange(next.length ? next : [{ name: '', lead_field: '', match_type: 'exact' }]);
  };

  return (
    <div style={{ background: '#fafbfc', border: '1px solid #e0e7ef', borderRadius: '6px', padding: '10px' }}>
      <div style={{ ...rowStyle, marginBottom: '8px' }}>
        <div style={{ fontSize: '11px', color: '#888', fontWeight: '600' }}>Column name</div>
        <div style={{ fontSize: '11px', color: '#888', fontWeight: '600' }}>Matches Lead field</div>
        <div style={{ fontSize: '11px', color: '#888', fontWeight: '600' }}>Match type</div>
        <div />
      </div>
      {rows.map((col, idx) => (
        <div key={idx} style={rowStyle}>
          <input
            value={col.name}
            onChange={e => updateRow(idx, { name: e.target.value })}
            placeholder="e.g. company_name"
            style={inputStyle}
          />
          <SearchableSelect
            options={buildMatchFieldOptions(allLeadFields, col.lead_field)}
            value={col.lead_field}
            onChange={v => updateRow(idx, { lead_field: v })}
            placeholder="Search fields…"
          />
          <select
            value={col.match_type || 'exact'}
            onChange={e => updateRow(idx, { match_type: e.target.value })}
            style={inputStyle}
          >
            {Object.entries(MATCH_TYPES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
          <button
            type="button"
            onClick={() => removeRow(idx)}
            title="Remove column"
            style={{ background: 'none', border: 'none', color: '#e74c3c', cursor: 'pointer', fontSize: '15px', padding: '4px' }}
          >
            ×
          </button>
        </div>
      ))}
      <button
        type="button"
        onClick={addRow}
        style={{ background: '#ecf0f1', border: '1px solid #ccc', borderRadius: '4px', padding: '5px 10px', fontSize: '12px', cursor: 'pointer', marginTop: '4px' }}
      >
        + Add column
      </button>
      <div style={{ fontSize: '11px', color: '#aaa', marginTop: '6px' }}>
        A lead only matches an entry when EVERY column above matches that same row (e.g. company name AND zip code).
      </div>
    </div>
  );
}
